import {inject, Pipe, PipeTransform } from '@angular/core';
import { DatasetWebConverter } from 'dev/components/elad.forms2/services/dataset.web.converter';

@Pipe({
  name: 'cpDbCase',
  pure: true
})
export class DbCasePipe implements PipeTransform { 
    private dsWebConverterSvc = inject(DatasetWebConverter);
    transform(value: string): string {
      return this.dsWebConverterSvc.dbCaseFunc(value);
  }
}